var map = {
	"./add-circle.svg": "./website/assets/icons/custom/add-circle.svg",
	"./add.svg": "./website/assets/icons/custom/add.svg",
	"./annotation.svg": "./website/assets/icons/custom/annotation.svg",
	"./arrow-down.svg": "./website/assets/icons/custom/arrow-down.svg",
	"./arrow-left.svg": "./website/assets/icons/custom/arrow-left.svg",
	"./arrow-right.svg": "./website/assets/icons/custom/arrow-right.svg",
	"./arrow-up.svg": "./website/assets/icons/custom/arrow-up.svg",
	"./arrow.svg": "./website/assets/icons/custom/arrow.svg",
	"./brightness.svg": "./website/assets/icons/custom/brightness.svg",
	"./checkbox-background.svg": "./website/assets/icons/custom/checkbox-background.svg",
	"./checkbox-foreground.svg": "./website/assets/icons/custom/checkbox-foreground.svg",
	"./checkmark.svg": "./website/assets/icons/custom/checkmark.svg",
	"./chevron-down-big.svg": "./website/assets/icons/custom/chevron-down-big.svg",
	"./chevron-down.svg": "./website/assets/icons/custom/chevron-down.svg",
	"./chevron-left.svg": "./website/assets/icons/custom/chevron-left.svg",
	"./chevron-right.svg": "./website/assets/icons/custom/chevron-right.svg",
	"./chevron-up.svg": "./website/assets/icons/custom/chevron-up.svg",
	"./close.svg": "./website/assets/icons/custom/close.svg",
	"./compare.svg": "./website/assets/icons/custom/compare.svg",
	"./contrast.svg": "./website/assets/icons/custom/contrast.svg",
	"./copyright.svg": "./website/assets/icons/custom/copyright.svg",
	"./download.svg": "./website/assets/icons/custom/download.svg",
	"./edit-line.svg": "./website/assets/icons/custom/edit-line.svg",
	"./edit.svg": "./website/assets/icons/custom/edit.svg",
	"./exit.svg": "./website/assets/icons/custom/exit.svg",
	"./eye-closed.svg": "./website/assets/icons/custom/eye-closed.svg",
	"./eye.svg": "./website/assets/icons/custom/eye.svg",
	"./file.svg": "./website/assets/icons/custom/file.svg",
	"./flag.svg": "./website/assets/icons/custom/flag.svg",
	"./flip.svg": "./website/assets/icons/custom/flip.svg",
	"./greyscale.svg": "./website/assets/icons/custom/greyscale.svg",
	"./hamburger.svg": "./website/assets/icons/custom/hamburger.svg",
	"./image.svg": "./website/assets/icons/custom/image.svg",
	"./infinity.svg": "./website/assets/icons/custom/infinity.svg",
	"./info-outline.svg": "./website/assets/icons/custom/info-outline.svg",
	"./info.svg": "./website/assets/icons/custom/info.svg",
	"./invert.svg": "./website/assets/icons/custom/invert.svg",
	"./lemniscate.svg": "./website/assets/icons/custom/lemniscate.svg",
	"./link.svg": "./website/assets/icons/custom/link.svg",
	"./metadata.svg": "./website/assets/icons/custom/metadata.svg",
	"./objects.svg": "./website/assets/icons/custom/objects.svg",
	"./open-new-window.svg": "./website/assets/icons/custom/open-new-window.svg",
	"./options.svg": "./website/assets/icons/custom/options.svg",
	"./panel-expand.svg": "./website/assets/icons/custom/panel-expand.svg",
	"./panel-reduce.svg": "./website/assets/icons/custom/panel-reduce.svg",
	"./pen.svg": "./website/assets/icons/custom/pen.svg",
	"./pencil-broken.svg": "./website/assets/icons/custom/pencil-broken.svg",
	"./pencil-down.svg": "./website/assets/icons/custom/pencil-down.svg",
	"./pencil-ghost.svg": "./website/assets/icons/custom/pencil-ghost.svg",
	"./pencil-guard.svg": "./website/assets/icons/custom/pencil-guard.svg",
	"./pencil-scale-indication.svg": "./website/assets/icons/custom/pencil-scale-indication.svg",
	"./pencil.svg": "./website/assets/icons/custom/pencil.svg",
	"./pending.svg": "./website/assets/icons/custom/pending.svg",
	"./picture.svg": "./website/assets/icons/custom/picture.svg",
	"./play.svg": "./website/assets/icons/custom/play.svg",
	"./private.svg": "./website/assets/icons/custom/private.svg",
	"./public.svg": "./website/assets/icons/custom/public.svg",
	"./publish.svg": "./website/assets/icons/custom/publish.svg",
	"./radio-foreground.svg": "./website/assets/icons/custom/radio-foreground.svg",
	"./refresh.svg": "./website/assets/icons/custom/refresh.svg",
	"./relations.svg": "./website/assets/icons/custom/relations.svg",
	"./rotate-left.svg": "./website/assets/icons/custom/rotate-left.svg",
	"./rotate-right.svg": "./website/assets/icons/custom/rotate-right.svg",
	"./saturation.svg": "./website/assets/icons/custom/saturation.svg",
	"./search.svg": "./website/assets/icons/custom/search.svg",
	"./settings.svg": "./website/assets/icons/custom/settings.svg",
	"./share.svg": "./website/assets/icons/custom/share.svg",
	"./slide-left.svg": "./website/assets/icons/custom/slide-left.svg",
	"./slide-right.svg": "./website/assets/icons/custom/slide-right.svg",
	"./social-facebook.svg": "./website/assets/icons/custom/social-facebook.svg",
	"./social-instagram.svg": "./website/assets/icons/custom/social-instagram.svg",
	"./social-twitter.svg": "./website/assets/icons/custom/social-twitter.svg",
	"./trash.svg": "./website/assets/icons/custom/trash.svg",
	"./user.svg": "./website/assets/icons/custom/user.svg",
	"./view-book.svg": "./website/assets/icons/custom/view-book.svg",
	"./view-gallery.svg": "./website/assets/icons/custom/view-gallery.svg",
	"./view-single.svg": "./website/assets/icons/custom/view-single.svg",
	"./warning.svg": "./website/assets/icons/custom/warning.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./website/assets/icons/custom sync recursive ^\\.\\/.*\\.svg$";